import { render, staticRenderFns } from "./DLGDetail.vue?vue&type=template&id=17e91052&"
import script from "./DLGDetail.vue?vue&type=script&lang=js&"
export * from "./DLGDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17e91052')) {
      api.createRecord('17e91052', component.options)
    } else {
      api.reload('17e91052', component.options)
    }
    module.hot.accept("./DLGDetail.vue?vue&type=template&id=17e91052&", function () {
      api.rerender('17e91052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/adm/DLGDetail.vue"
export default component.exports